import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUiStore } from '@/stores/ui';
import { useWorkspaceStore } from '@/stores/workspace';

export const useGlobalShortcuts = () => {
  const navigate = useNavigate();
  const {
    setIsCommandPaletteOpen,
    setIsFileExplorerSearchVisible,
    setIsGitPanelVisible,
    isGitPanelVisible,
    isFileExplorerSearchVisible,
  } = useUiStore();
  const createNewFile = useWorkspaceStore((state) => state.createNewFile);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Global Search shortcut
      if (event.key === 'F' && (event.metaKey || event.ctrlKey) && event.shiftKey) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (isFileExplorerSearchVisible) {
          const searchInput = document.getElementById('workspace-search-input');
          // "should only close the search results if the search input isn't in focus"
          if (document.activeElement === searchInput) {
            setIsFileExplorerSearchVisible(false);
          } else {
            searchInput.focus();
          }
        } else {
          navigate('/pages/workspace/');
          setIsFileExplorerSearchVisible(true);
          setIsGitPanelVisible(false);
        }
      }

      // Command Palette shortcut
      if (event.key === 'p' && (event.metaKey || event.ctrlKey)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        navigate('/pages/workspace/');
        setIsCommandPaletteOpen(true);
      }

      // New file shortcut
      if (event.key === 'n' && (event.metaKey || event.ctrlKey)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        createNewFile();
        navigate('/pages/workspace/');
      }

      // Git panel toggle
      if (event.key === 'c' && event.altKey) {
        event.preventDefault();
        event.stopImmediatePropagation();
        navigate('/pages/workspace/');
        setIsGitPanelVisible(!isGitPanelVisible);
        setIsFileExplorerSearchVisible(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown, true);
    return () => {
      window.removeEventListener('keydown', handleKeyDown, true);
    };
  }, [
    navigate,
    createNewFile,
    setIsCommandPaletteOpen,
    isGitPanelVisible,
    isFileExplorerSearchVisible,
    setIsFileExplorerSearchVisible,
    setIsGitPanelVisible,
  ]);
};